<template>
     <transition :name="effect">
        <div class="video-player" v-if="status">
            <div class="video-box">
                <div class="video-header clearfix">
                    <b role="button" class="video-close pull-right" @click="close">×</b>
                </div>
                <div class="video-body">
                    <!-- 普通视频 -->
                    <video
                        class="video"
                        :src="url"
                        webkit-playsinline
                        playsinline
                        controls=""
                        :muted="false"
                        preload="meta"
                        autoplay="false"
                        loop="false"
                        ref="video"
                        v-if="url"
                    ></video>
                    <!-- YouTube视频 -->
                    <iframe
                        id="ytplayer"
                        type="text/html"
                        :width="isMobile ? '100%' : '1280'"
                        :height="isMobile ? setHight : '720'"
                        frameborder="0"
                        :src="youtube"
                        allowfullscreen
                        v-if="youtube"
                    />
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

import { platform } from "~/js/utils"

export default {
    name: 'VideoPlayer',
    data () {
        return {
            effect: 'fade-in',
            status: false,
            url: '',
            youtube: '',
            isMobile: platform.isMobile,
            setHight: 0
        }
    },
    computed: {
        changeStatus () {
            if(this.url) {
                this.status = true 
            }
        },
        player () {
            return this.$refs.video
        }
    },
    methods: {
        play (url) {
            // url必填
            if(!url) {
                console.log('video url is required.')
                return
            }

            // 写入url
            if(/youtube\.com/.test(url)) {
                this.youtube = url
            } else {
                this.url = url
            }

            // 弹出
            this.show()
        },
        show () {
            this.status = true 
            this.changeEffect('fade-out')
        },
        close () {
            this.status = false
            this.url = this.youtube = ''
            this.changeEffect('fade-in')
        },
        changeEffect (name) {
            setTimeout(() => {
                this.effect = name
            }, 3e2)
        }
    },
    mounted() {
        
        let resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize'
        let setSize = () => {
            this.setHight = document.documentElement.clientHeight
        }
        window.addEventListener(resizeEvt, setSize, false)
        setSize()
    }
}
</script>

<style lang="scss">
    .video-player {
        display: table;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        font-size: 36px;
        background-color: rgba(0,0,0,0.5);
        z-index: 10;
        .video-box {
            display: table-cell;
            height: auto;
            vertical-align: middle;
            padding-top: 48px;
            position: relative;
            .video-header,
            .video-body {
                width: 1280px;
                margin: auto;
            }
            .video-header {
                position: absolute;
                left: 50%;
                margin-top: -48px;
                margin-left: -640px;
            }
            .video-close {
                width: 48px;
                line-height: 48px;
                text-align: center;
                font-size: 100%;
                font-weight: 100;
                color: #fff;
                background-color: #000;
                transition: background-color 0.25s, color 0.25s;
                cursor: pointer;
                &:hover {
                    color: #f56c6c;
                    background-color: #fff;
                }
            }
            .video {
                width: 100%;
            }
        }
    }
    @media (max-width: 1280px) {
        .video-player {
            .video-box {
                padding-top: 0;
                .video-header,
                .video-body {
                    width: 100%;
                }
                .video-header {
                    left: 0.5%;
                    margin-top: auto;
                    margin-left: auto;
                    z-index: 2;
                }
                .video-close {
                    width: 40px;
                    line-height: 40px;
                    font-size: 90%;
                }
            }
        }
    }
</style>
